import React from 'react';
import { XCircleIcon, CheckCircleIcon, TrendingUpIcon } from 'lucide-react';
export function InactionCostSection() {
  const withoutProtocol = [{
    label: 'Supermercado express sin planificar',
    icon: XCircleIcon
  }, {
    label: 'Delivery 3 veces por semana',
    icon: XCircleIcon
  }, {
    label: 'Desperdicio de comida semanal',
    icon: XCircleIcon
  }];
  const withProtocol = [{
    label: 'Compra inteligente y planificada',
    icon: CheckCircleIcon
  }, {
    label: 'Stockeo cíclico en mayoristas',
    icon: CheckCircleIcon
  }, {
    label: 'Zero Waste — nada se pierde',
    icon: CheckCircleIcon
  }];
  return <section className="w-full bg-[#F5F2EB] py-16 px-4" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3022] mb-4 text-center" data-id="element-155">
          El Costo de la Inacción
        </h2>
        <p className="text-lg text-[#5a5a4f] mb-12 text-center max-w-2xl mx-auto" data-id="element-156">
          Cada mes que pasa sin un sistema, estás perdiendo dinero que podría
          estar en tu bolsillo.
        </p>

        {/* Comparison Table */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-157">
          {/* Without Protocol */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-158">
            <h3 className="text-xl font-bold text-[#1a2332] mb-6 text-center" data-id="element-159">
              ❌ Sin el Protocolo
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-160">
              {withoutProtocol.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-center gap-3" data-id="element-161">
                    <Icon className="w-5 h-5 text-[#ef4444] flex-shrink-0" data-id="element-162" />
                    <span className="text-gray-700" data-id="element-163">{item.label}</span>
                  </li>;
            })}
            </ul>
            <div className="border-t border-gray-200 pt-6 text-center" data-id="element-164">
              <p className="text-sm text-gray-500 mb-1" data-id="element-165">Total mensual</p>
              <p className="text-3xl font-bold text-[#ef4444]" data-id="element-166">$450.000</p>
              <p className="text-sm text-gray-400" data-id="element-167">CLP / mes</p>
            </div>
          </div>

          {/* With Protocol */}
          <div className="bg-[#f0faf0] rounded-2xl p-8 border-2 border-[#22c55e] shadow-md relative" data-id="element-168">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-169">
              <span className="bg-[#22c55e] text-white text-xs font-bold px-4 py-1 rounded-full" data-id="element-170">
                RECOMENDADO
              </span>
            </div>
            <h3 className="text-xl font-bold text-[#1B3022] mb-6 text-center" data-id="element-171">
              ✅ Con Solo-Survival
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-172">
              {withProtocol.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-center gap-3" data-id="element-173">
                    <Icon className="w-5 h-5 text-[#22c55e] flex-shrink-0" data-id="element-174" />
                    <span className="text-[#1B3022]" data-id="element-175">{item.label}</span>
                  </li>;
            })}
            </ul>
            <div className="border-t border-[#22c55e]/30 pt-6 text-center" data-id="element-176">
              <p className="text-sm text-[#1B3022]/60 mb-1" data-id="element-177">Total mensual</p>
              <p className="text-3xl font-bold text-[#1B3022]" data-id="element-178">$270.000</p>
              <p className="text-sm text-[#1B3022]/50" data-id="element-179">CLP / mes</p>
            </div>
          </div>
        </div>

        {/* Savings Highlight */}
        <div className="bg-[#1B3022] rounded-2xl px-8 py-8 text-center" data-id="element-180">
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-181">
            <TrendingUpIcon className="w-8 h-8 text-[#22c55e]" data-id="element-182" />
            <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-183">
              Ahorro Real:
            </h3>
          </div>
          <p className="text-4xl md:text-5xl font-bold text-[#22c55e] mb-2" data-id="element-184">
            $180.000 extra
          </p>
          <p className="text-lg text-white/80" data-id="element-185">en tu bolsillo cada mes</p>
        </div>
      </div>
    </section>;
}